import React from "react"
import classNames from "classnames"
import { FixedSizeList as WindowList } from "react-window"
import AutoSizer from "react-virtualized-auto-sizer"
import _ from "lodash"

import { Idea, Project, ID, ProjectStatus } from "../../../../model/types"
import { useNana } from "../../../hooks/useNana"
import IdeaBox, { GhostBox } from "../../../components/idea_box"

const ListItem = ({
  project,
  isOpen,
  style,
  setOpenProjectId,
}: {
  project: Project
  isOpen: boolean
  style: React.CSSProperties
  setOpenProjectId: (id: ID) => void
}) => {
  const { model } = useNana()
  const goal: Idea | null = project.goalId
    ? model.getIdea(project.goalId)
    : null
  const attachedIdeas = model
    ? project.ideaIds.map((id) => model.fetchIdea(id))
    : []
  return (
    <li onClick={() => setOpenProjectId(project.id)} style={style}>
      <div
        className={classNames(
          "h-24 overflow-hidden px-4 py-4 flex flex-row justify-between border-b  hover:bg-zinc-100 dark:border-zinc-800  dark:hover:border-zinc-700 dark:hover:bg-zinc-800 cursor-pointer",
          {
            "bg-white dark:bg-gray-900": !isOpen,
            "bg-sky-50 dark:bg-sky-950 hover:bg-sky-100": isOpen,
          }
        )}
        // style={project.status == "new" ? { height: "104px" } : {}}
      >
        <div className="flex flex-col gap-2 items-center justify-between ">
          {goal && <IdeaBox idea={goal} />}
          {!goal && <GhostBox type={"goal"} />}
        </div>

        <div className="min-w-0 flex grow flex-col justify-between items-start px-4">
          <div className="flex flex-col justify-start items-stretch">
            <div
              className={classNames(
                "text-sm font-medium line-clamp-2 overflow-hidden text-ellipsis",
                {
                  "break-all": !project.name,
                  "break-words": !!project.name,
                }
              )}
            >
              {project.name}
            </div>
          </div>
          <div
            className={classNames("flex gap-1 h-8 overflow-x-hidden", {
              "opacity-50": !isOpen,
            })}
          >
            {attachedIdeas.map((idea) => (
              <IdeaBox key={idea.id} idea={idea} shadow={false} />
            ))}
          </div>
        </div>
      </div>
    </li>
  )
}

const ListState: { in_progress: number; completed: number } = {
  in_progress: 0,
  completed: 0,
}

const List = ({
  projects,
  openProject,
  setOpenProjectId,
  projectStatus,
}: {
  projects: Project[]
  openProject: Project | null
  setOpenProjectId: (id: ID) => void
  projectStatus: ProjectStatus
}) => {
  const { model } = useNana()
  return (
    <div
      id="projects"
      className="overflow-y-auto space-y-3"
      style={{ flex: "1 1 auto" }}
      data-testid={"projects-list-" + projectStatus}
    >
      <AutoSizer>
        {({ height, width }) => (
          <WindowList
            innerElementType={"ul"}
            height={height}
            itemCount={projects.length}
            itemSize={110}
            width={width}
            onScroll={({ scrollOffset }) =>
              (ListState[projectStatus] = scrollOffset)
            }
            initialScrollOffset={ListState[projectStatus]}
          >
            {({ index, style }) => {
              const project = projects[index]
              return (
                <ListItem
                  key={project.id}
                  style={style}
                  project={project}
                  isOpen={!!openProject && project.id === openProject.id}
                  setOpenProjectId={setOpenProjectId}
                />
              )
            }}
          </WindowList>
        )}
      </AutoSizer>
    </div>
  )
}

export default List
